module.exports = __webpack_public_path__ + "img/check-white.c7695be4.svg";